module.exports = __webpack_public_path__ + "media/images/male_no_picture_seventy_six-f4a67308.png";